<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-lg-12">
        <div class="row">
          <div class="col-lg-3 col-md-6 col-12">
            <card
              :title="stats.money.title"
              :value="(this.$store.state.projects).length"
              :percentage="stats.money.percentage"
              :iconClass="stats.money.iconClass"
              :iconBackground="stats.money.iconBackground"
              :detail="stats.money.detail"
              directionReverse
            ></card>
          </div>
          <div class="col-lg-3 col-md-6 col-12">
            <card
              :title="stats.users.title"
              :value="stats.users.value"
              :percentage="stats.users.percentage"
              :iconClass="stats.users.iconClass"
              :iconBackground="stats.users.iconBackground"
              :detail="stats.users.detail"
              directionReverse
            ></card>
          </div>
          <div class="col-lg-3 col-md-6 col-12">
            <card
              :title="stats.clients.title"
              :value="stats.clients.value"
              :percentage="stats.clients.percentage"
              :iconClass="stats.clients.iconClass"
              :iconBackground="stats.clients.iconBackground"
              :percentageColor="stats.clients.percentageColor"
              :detail="stats.clients.detail"
              directionReverse
            ></card>
          </div>
          <div class="col-lg-3 col-md-6 col-12">
            <card
              :title="stats.sales.title"
              :value="stats.sales.value"
              :percentage="stats.sales.percentage"
              :iconClass="stats.sales.iconClass"
              :iconBackground="stats.sales.iconBackground"
              :detail="stats.sales.detail"
              directionReverse
            ></card>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-7 mb-lg">
            <!-- line chart -->
            <div class="card z-index-2">
              <gradient-line-chart />
            </div>
          </div>
          <div class="col-lg-5">
            <carousel />
          </div>
        </div>
        <div class="row mt-4">
          <div class="col-lg-12 mb-lg-0 mb-4">
            <div class="card">
              <div class="p-3 pb-0 card-header">
                <div class="d-flex justify-content-between">
                  <h6 class="mb-2">Recent Projects</h6>
                </div>
              </div>
              <div class="table-responsive">
                <table class="table align-items-center">
                  <tbody>
                    <tr v-for="project in this.$store.state.projects" v-bind:key="project.id">
                      <td class="w-30">
                        <div class="px-2 py-1 d-flex align-items-center">
                          <div class="ms-4">
                            <p class="mb-0 text-xs font-weight-bold">Project:</p>
                            <h6 class="mb-0 text-sm">{{ project.name }}</h6>
                          </div>
                        </div>
                      </td>
                      <td>
                        <div class="text-center">
                          <p class="mb-0 text-xs font-weight-bold">Client:</p>
                          <h6 class="mb-0 text-sm">{{ project.client }}</h6>
                        </div>
                      </td>
                      <td>
                        <div class="text-center">
                          <p class="mb-0 text-xs font-weight-bold">Operator:</p>
                          <h6 class="mb-0 text-sm">{{ project.operator }}</h6>
                        </div>
                      </td>
                      <td class="text-sm align-middle">
                        <div class="text-center col">
                          <p class="mb-0 text-xs font-weight-bold">Date created:</p>
                          <h6 class="mb-0 text-sm">{{ project.created_at }}</h6>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <!--
            <div class="col-lg-5">
              <categories-card />
            </div>
          -->
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Card from "@/examples/Cards/Card.vue";
import GradientLineChart from "@/examples/Charts/GradientLineChart.vue";
import Carousel from "./components/Carousel.vue";
//import CategoriesCard from "./components/CategoriesCard.vue";
import axios from "axios";

export default {
  name: "dashboard-default",
  data() {
    return {
      projects: [],
      blocks: [],
      projectsWithBlocks: [],
      projectBlocks:[],
      stats: {
        money: {
          title: "Projects",
          value: (this.$store.state.projects).length,
          percentage: "",
          iconClass: "ni ni-money-coins",
          detail: "total projects",
          iconBackground: "bg-gradient-primary",
        },
        users: {
          title: "Total Users",
          value: "1",
          percentage: "",
          iconClass: "ni ni-world",
          iconBackground: "bg-gradient-danger",
          detail: "coming soon",
        },
        clients: {
          title: "Total Orders",
          value: "0",
          percentage: "",
          iconClass: "ni ni-paper-diploma",
          percentageColor: "text-danger",
          iconBackground: "bg-gradient-success",
          detail: "Coming soon",
        },
        sales: {
          title: "Suppliers",
          value: "0",
          percentage: "",
          iconClass: "ni ni-cart",
          iconBackground: "bg-gradient-warning",
          detail: "Coming Soon",
        },
      },
      sales: this.$store.state.projects,
    };
  },
  components: {
    Card,
    GradientLineChart,
    Carousel,
    //CategoriesCard,
  },
  computed(){
    const projects = this.$store.state.projects
    const blocks = this.$store.state.blocks

    

    this.projectBlocks = projects.map((project) => ({
      ...project,
      blocks: blocks.filter(block => block.project === project.id)
    })
    
    )
  },
  mounted(){
    setInterval(() => {
      this.getProjects()
      this.getBlocks()
    }, 2000)
  },
  created(){
    this.getProjects();
    this.getBlocks();
  },
  methods:{
    getProjects(){
      axios.get('/api/v1/projects_all/')
            .then(response => {
              console.log(response.data)
              this.$store.commit("setProjects", response.data)
            })
            .catch((err) => console.error(err));
    },
    getBlocks(){
      axios
          .get('/api/v1/blocks/')
          .then(response => {
            console.log(response.data)
            this.$store.commit("setBlocks", response.data)     
          })
          .catch((err) => console.error(err));
    },
  }
};
</script>
